import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from "@angular/core";

@Component({
  selector: "app-autocomplete-email-input",
  templateUrl: "./autocomplete-email-input.component.html",
  styleUrls: ["./autocomplete-email-input.component.scss"],
})
export class AutocompleteEmailInputComponent implements OnInit, OnChanges {
  @ViewChild("dropdown") dropdown!: ElementRef;
  selectedItem!: any;
  @Input() ctrlName: any;
  @Input() suggestions: any[] = [];
  @Input() isMultipleSelected: boolean = false;
  @Input() isCompleteOnFocus: boolean = false;
  @Input() isDisabled: boolean = false;
  @Input() dataFrom: any = "";
  @Output() searchEvent = new EventEmitter<any>();
  @Output() emailChange = new EventEmitter<any>();
  showDropdown: boolean = false;
  storedUserList: any;

  constructor(
    private readonly cdr: ChangeDetectorRef,
    public eRef: ElementRef,
  ) {}

  @HostListener("document:click", ["$event"])
  clickOutside(event: Event): void {
    if (
      !this.eRef.nativeElement.contains(event.target) &&
      !this.dropdown?.nativeElement?.contains?.(event.target)
    ) {
      this.showDropdown = false;
    }
  }

  ngOnInit(): void {
    if (!this.isMultipleSelected && (this.ctrlName || this.ctrlName === "")) {
      this.selectedItem = this.ctrlName;
    }

    if (this.isMultipleSelected && this.ctrlName) {
      this.selectedItem = this.ctrlName;
    }

    this.storedUserList = JSON.parse(
      sessionStorage.getItem("suggestedUserList") || "[]",
    );
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.ctrlName?.currentValue && !this.isMultipleSelected) {
      this.selectedItem = changes.ctrlName.currentValue;
    }

    if (this.isMultipleSelected) {
      this.selectedItem = this.ctrlName || [];
    }
  }

  onSearch(event: any): void {
    const query = event.query;
    setTimeout(() => {
      this.searchEvent.emit(query);
    }, 1500);
  }

  onSelectItem(event: any): void {
    if (this.isMultipleSelected) {
      if (
        event?.email &&
        !this.selectedItem.some((item: any) => item.email === event.email)
      ) {
        this.selectedItem = [...this.selectedItem, event];
      }
    } else {
      this.selectedItem = event?.email ? event : null;
    }
    this.emailChange.emit(
      this.isMultipleSelected
        ? this.selectedItem
        : this.selectedItem?.email || null,
    );
  }

  getData() {
    this.showDropdown = true;
  }

  hideData() {
    this.showDropdown = false;
  }

  onEmailClick(email: string): void {
    const isDuplicate = this.selectedItem.some(
      (item: any) => item.email === email,
    );
    if (!isDuplicate) {
      this.selectedItem = [...this.selectedItem, { email }];
      this.emailChange.emit(this.selectedItem);
    }
    this.showDropdown = false;
    this.cdr.detectChanges();
  }

  onRemoveItem(email: any): void {
    this.selectedItem = this.selectedItem.filter(
      (item: any) => item.email !== email.email,
    );
    this.emailChange.emit(this.selectedItem);
  }
}
